import { parseTemplate } from 'url-template';
import mapPagination from '~/Api/Pagination/mapPagination';
import Pagination from '~/Api/Pagination/Pagination';
import ApiClient from '~/ApiClient';

import Filter from './Filter';
import mapUserProductGroup, { type RawUserProductGroup } from './mapUserProductGroup';
import UserProductGroup from './UserProductGroup';

export interface Result {
	items: UserProductGroup[];
	pagination: Pagination;
}

export default function findUserProductGroups(
	client: ApiClient,
	userId: string,
	filter: Filter,
	page: number,
	perPage: number
): Promise<Result> {
	const url = parseTemplate(
		'users/{userId}/product-groups{?filter-parentId,filter-hasParent,filter-name,page,perPage}'
	);

	return client
		.fetch(
			url.expand({
				userId,
				'filter-parentId': filter.parentId,
				[filter.parentId !== null ? '' : 'filter-hasParent']:
					filter.hasParent === null ? 'any' : filter.hasParent ? 'yes' : 'no',
				'filter-name': filter.name,
				page,
				perPage,
			})
		)
		.then((response) => response.json())
		.then((response) => ({
			items: response.items.map((group: RawUserProductGroup) => mapUserProductGroup(group)),
			pagination: mapPagination(response.pagination),
		}));
}
